function Error() {
  return <div>Error! 페이지를 찾을 수 없습니다.</div>;
}

export default Error;
